<template>
  <div :class="$setClasses">
    <card-flex v-if="cardContent"
               no-box-shadow
               :mobile-wrapper-column="true"
               class="step-comparator-wrapper__header__card-flex"
               :icon="cardIcon"
               icon-green
               :content="cardContent">
    </card-flex>
    <div v-if="content"
         v-html="content"></div>
    <card-flex v-if="memoCardContent"
               :class="[$vClass('memo'),
                'step-comparator-wrapper__header__card-flex']"
               :content="memoCardContent"
               :icon="stepConfig.memoCard.icon"
               icon-green
               :mobile-wrapper-column="true"
               no-box-shadow/>
    <el-card v-if="getTextVersion('signature.notice')"
             :class="$vClass('signing')">
      <p :class="$vClass('card__notice')"
         v-html="getTextVersion('signature.notice')"></p>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CardFlex from '@/utils/components/CardFlex.vue';
import MoveManager from '@/utils/components/MoveManager.vue';

export default {
  name: 'Signature',
  nameClassStyle: 'signature',
  extends: MoveManager,
  components: {
    CardFlex,
  },
  computed: {
    ...mapGetters({
      isSigningModalDisplayed: 'comparatorStore/isSigningModalDisplayed',
      comparatorConfig: 'configStore/comparatorConfig',
      loading: 'configStore/loading',
    }),
    stepConfig() {
      return this.comparatorConfig.signature;
    },
    cardIcon() {
      return this.stepConfig && this.stepConfig.card && this.stepConfig.card.icon;
    },
    memoCardContent() {
      return this.stepConfig
        && this.getTextVersion(this.stepConfig.memoCard && this.stepConfig.memoCard.content,
          this.getTextParams);
    },
    content() {
      return this.stepConfig && this.getTextVersion(this.stepConfig.content, this.getTextParams);
    },
    cardContent() {
      if (this.stepConfig && this.stepConfig.card) {
        return this.$te(this.stepConfig.card.content)
          ? this.getTextVersion(this.stepConfig.card && this.stepConfig.card.content,
            this.getTextParams)
          : this.stepConfig.card.content;
      }
      return '';
    },
  },
  created() {
    if (this.stepConfig && this.stepConfig.options && this.stepConfig.options.autoSigningModal) {
      this.displaySigningModal(this.offer);
    }
  },
  methods: {
    ...mapActions({
      displaySigningModal: 'comparatorStore/displaySigningModal',
    }),
    nextStep() {
      this.displaySigningModal(this.offer);
    },
    setLoading(value) {
      this.$store.commit('configStore/SET_LOADING', value);
    },
  },
};
</script>

<style scoped lang="scss">
.signature {

  &__memo {
    background: transparent;

    :deep(svg) {
      color: var(--nxt-color-secondary);
    }
  }
}
</style>
